"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var areCoinsDisplayed = function areCoinsDisplayed(_ref) {
  var hasRewardsFeature = _ref.hasRewardsFeature,
      activatedAt = _ref.activatedAt,
      date = _ref.date;

  if (hasRewardsFeature) {
    return activatedAt ? (0, _moment["default"])(date).isSameOrAfter(activatedAt) : true;
  }

  return false;
};

var _default = areCoinsDisplayed;
exports["default"] = _default;
//# sourceMappingURL=areCoinsDisplayed.js.map